(function () {
    'use strict';

    angular.module("imApp").factory("orderHeadCreateProjectService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 3672,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 3673,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
